import React, { useState, useRef, useEffect } from "react";
import {
  Divider,
  IconButton,
  Typography,
  Box, Button,
  Tabs, Tab, Paper, Grid, FormControlLabel, Switch, TextField, Select, MenuItem, FormControl, InputLabel
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useParams } from "react-router-dom";

import ComboApi from "Componentes/ComboApi";
import GridListadoEditable from "Componentes/GridListadoEditable";
import InfoCostes from "Componentes/InfoCostes";
import MigaPan from "Componentes/MigaPan";
import { peticionGet } from "Componentes/ComponenteAxios";
import { peticionPost } from "Componentes/ComponenteAxios";
import { peticionPut } from "Componentes/ComponenteAxios";
import { peticionDelete } from "Componentes/ComponenteAxios";

// Componente de TabPanel optimizado
const TabPanel = React.memo(({ children, value, index }) => {
  return value === index ? <Box sx={{ mt: 2 }}>{children}</Box> : null;
});

const PartesTrabajoDetalle = () => {

  const { id } = useParams();
  const migaPanRef = useRef();
  // const formularioTitulo = "Edicion de parte de Trabajo";

  const [cargando, setCargando] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);

  const [cabeceraParte, setCabeceraParte] = useState({
    operacion_de_arrastre: "No",
    toneladas_arrastre: "0",
    toneladas_arrastre: "0",
    almacen_id: "",
  });

  const [subTabPrimeraLinea, setSubTabPrimeraLinea] = useState(0);
  const [mediosMecanicos, setMediosMecanicos] = useState([]);

  const [personalPrimeraLinea, setPersonalPrimeraLinea] = useState([]);
  const [filtroPrimeraLineaSestisan, setFiltroPrimeraLineaSestisan] = useState([]);
  const [filtroPrimeraLineaCadevesa, setFiltroPrimeraLineaCadevesa] = useState([]);
  const [filtroPrimeraLineaAdeccoFijoDiscontinuo, setFiltroPrimeraLineaAdeccoFijoDiscontinuo] = useState([]);
  const [filtroPrimeraLineaAdeccoEventuales, setFiltroPrimeraLineaAdeccoEventuales] = useState([]);

  const [personalSegundaLinea, setPersonalSegundaLinea] = useState([]);
  const [personalColla, setPersonalColla] = useState([]);
  const [pluses, setPluses] = useState([]);

  const [valorMedioMecanicoEnComboNuevoMediosMecanico, setValorMedioMecanicoEnComboNuevoMediosMecanico] = useState();

  const [breadcrumbs, setBreadcrumbs] = useState([
    { label: "", href: `` }
  ]);

  // ************************************************************************************
  // ********** RECUPERA LOS DATOS NECESARIOS, aunque hay que llamarlo desde un useEffect
  // ************************************************************************************
  const cargarCabecera = async () => {

    setCargando(true);

    const { peticion: parte, error } = await peticionGet(`/partesTrabajo/${id}`);

    setCabeceraParte(parte?.datos || {});

    setMediosMecanicos((parte?.datos?.medios_mecanicos || []).sort((a, b) => { //Lo ordeno para ponerlo en el grid
      const nombreA = a.medio_mecanico?.nombre?.toUpperCase() || "";
      const nombreB = b.medio_mecanico?.nombre?.toUpperCase() || "";
      return nombreA.localeCompare(nombreB);
    }));

    const lista = parte?.datos?.personal_primera_linea || [];

    setPersonalPrimeraLinea(lista);

    setFiltroPrimeraLineaSestisan(
      lista
        .filter(p => p.categoria?.colectivo_id === 1)
        .sort((a, b) =>
          (a.categoria?.nombre || "").localeCompare(b.categoria?.nombre || "")
        )
    );

    setFiltroPrimeraLineaAdeccoFijoDiscontinuo(
      lista
        .filter(p => p.categoria?.colectivo_id === 2)
        .sort((a, b) =>
          (a.categoria?.nombre || "").localeCompare(b.categoria?.nombre || "")
        )
    );

    setFiltroPrimeraLineaAdeccoEventuales(
      lista
        .filter(p => p.categoria?.colectivo_id === 3)
        .sort((a, b) =>
          (a.categoria?.nombre || "").localeCompare(b.categoria?.nombre || "")
        )
    );

    setFiltroPrimeraLineaCadevesa(
      lista
        .filter(p => p.categoria?.colectivo_id === 4)
        .sort((a, b) =>
          (a.categoria?.nombre || "").localeCompare(b.categoria?.nombre || "")
        )
    );

    setPersonalSegundaLinea(parte?.datos?.personal_segunda_linea);
    setPersonalColla(parte?.datos?.personal_colla);
    setPluses(parte?.datos?.pluses);

    setBreadcrumbs([
      { label: "Operaciones", href: "/Operaciones" },
      {
        label: `Operación ${parte?.datos?.operacion?.ano || id} / ${parte?.datos?.operacion?.codigo || id} / ${parte?.datos?.operacion?.suboperacion || id}`,
        href: `/Operaciones/Editar/${parte?.datos?.operacion?.id}`
      },
      { label: `Parte de Trabajo`, href: "#" }
    ]);

    setCargando(false);

  };

  useEffect(() => {
    cargarCabecera();
  }, [id]);

  const handleTabsChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  // ************************************************************************************
  // ************ MODIFICACIONES DE LINEA DE DETALLE ************************************
  // ************************************************************************************
  const modificarLineaDetalle = async (newRow, oldRow, url) => {
    const { peticion, error } = await peticionPut(url, newRow);

    migaPanRef.current?.mostrarSnack({
      mensaje: peticion?.mensajeSnack || (error ? "Ha ocurrido un error" : "Actualización correcta"),
      tipo: peticion?.tipoSnack || (error ? "error" : "success"),
    });

    if (!error) {
      await cargarCabecera();
      return newRow;
    }

    return oldRow;
  };

  // ************************************************************************************
  // ******************* BORRADO DE LINEA DE DETALLE ************************************
  // ************************************************************************************
  const eliminarLineaDetalle = async (row, endpoint) => {
    if (!window.confirm("¿Estás seguro de que deseas eliminar esta línea?")) return;
    const { peticion, error } = await peticionGet(endpoint);

    migaPanRef.current?.mostrarSnack({
      mensaje: peticion?.mensajeSnack || (error ? "Error al eliminar" : "Eliminado correctamente"),
      tipo: peticion?.tipoSnack || (error ? "error" : "success"),
    });

    if (!error) await cargarCabecera();
  };

  // *******************************************************************************
  // ******************* NUEVA LINEA DE DETALLE ************************************
  // *******************************************************************************
  const nuevaLineaDetalle = async (tipo) => {
    let nuevoRegistro = {};
    let url = "";

    if (tipo === 'medioMecanico') {
      nuevoRegistro = {
        parte_trabajo_id: id,
        medio_mecanico_id: valorMedioMecanicoEnComboNuevoMediosMecanico,
        tarifa_id: cabeceraParte.tarifa_id,
      };
      url = "/partesTrabajo/nuevoMedioMecanico";

    }

    const { peticion, error } = await peticionPost(url, nuevoRegistro);
    if (error) {
      migaPanRef.current?.mostrarSnack({
        mensaje: peticion?.mensajeSnack || "No se pudo crear el nuevo registro",
        tipo: peticion?.tipoSnack || "error"
      });
      return;
    } else {
      migaPanRef.current?.mostrarSnack({
        mensaje: peticion?.mensajeSnack || "El nuevo registro ha sido creado",
        tipo: peticion?.tipoSnack || "success"
      });
    }

    await cargarCabecera();
  };

  // ************************************************************************
  // ********** COMIENZA EL ENTORNO GRÁFICO
  // ************************************************************************

  return (
    <Box className="box-contenido-alineado-izquierda">

      <MigaPan
        ref={migaPanRef}
        tituloSeccion={(() => {
          let tituloSeccion = `Operacion ${cabeceraParte?.operacion?.codigo_completo ?? ""}`;
          tituloSeccion += " - ";
          tituloSeccion += `${cabeceraParte?.operacion?.operativa_nombre ?? ""}`;
          tituloSeccion += " (";
          tituloSeccion += `${cabeceraParte?.operacion?.estado ?? ""}`;
          tituloSeccion += ") - ";
          tituloSeccion += `${cabeceraParte?.operacion?.cliente_nombre ?? ""}`;
          tituloSeccion += " - ";
          tituloSeccion += `${cabeceraParte?.operacion?.mercancia_nombre ?? ""}`;

          return tituloSeccion;
        })()}
        breadcrumbs={breadcrumbs}
      />

      <Tabs value={tabIndex} onChange={handleTabsChange}>
        <Tab label="Datos Generales" />
        <Tab label="Primera Linea" />
        <Tab label="Segunda Linea" />
        <Tab label="Colla" />
        <Tab label="Pluses" />
        <Tab label="Medios Mecánicos" />
        <Tab label="Arrastre" />
        <Tab label="Utilidades" />

      </Tabs>

      {/*************************************************************************
      ********** Panel 0 Datos Generales
      ************************************************************************ */}
      <TabPanel value={tabIndex} index={0}>
        <Grid container justifyContent="start">
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Typography variant="body1">
                    <strong>Fecha: </strong>
                    {new Date(cabeceraParte.fecha).toLocaleDateString("es-ES")}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Jornada: </strong>
                    {cabeceraParte?.jornada?.nombre || "Sin Jornada"}
                  </Typography>

                  <Divider sx={{ mt: 1, mb: 1 }} />

                  <InfoCostes label="Primera Linea" valor={cabeceraParte.suma_costes_personal_primera_linea} />
                  <InfoCostes label="Segunda Linea" valor={cabeceraParte.suma_costes_personal_segunda_linea} />
                  <InfoCostes label="Colla" valor={cabeceraParte.suma_costes_personal_colla} />
                  <InfoCostes label="Pluses" valor={cabeceraParte.suma_costes_pluses} />
                  <InfoCostes label="Medios Mecánicos" valor={cabeceraParte.suma_costes_medios_mecanicos} />
                  <Divider sx={{ mt: 1, mb: 1 }} />

                  <InfoCostes label="Suma Parte de Trabajo" valor={cabeceraParte.suma_costes_total_parte} />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </TabPanel>

      {/*************************************************************************
      ********** Panel 1 Primera Linea
      ************************************************************************ */}
      <TabPanel value={tabIndex} index={1}>
        <Typography variant="h5" gutterBottom mb={2}>Personal de Primera Linea</Typography>

        {/*************************************************************************
          ********** SubPaneles de primera linea
          ************************************************************************ */}

        <Tabs
          value={subTabPrimeraLinea}
          onChange={(e, v) => setSubTabPrimeraLinea(v)}
          sx={{ mb: 2 }}
        >
          <Tab label="Sestisan" />
          <Tab label="Cadevesa" />
          <Tab label="Adecco - Eventuales" />
          <Tab label="Adecco - Fijos Discontinuos" />
        </Tabs>


        {/* SESTISAN */}
        {subTabPrimeraLinea === 0 && (
          <Box sx={{ mb: 2 }}>
            <GridListadoEditable
              pageSize={100}
              iconoEditar="No"
              iconoBorrar="No"
              rows={filtroPrimeraLineaSestisan}
              columnas={[
                { field: "nombre", headerName: "Nombre", flex: 1, renderCell: p => p.row.categoria?.nombre || "—" },
                { field: "cantidad", headerName: "Cantidad", flex: 1 },
                { field: "horas", headerName: "Horas", flex: 1 },
                { field: "coste", headerName: "Coste", flex: 1 },
                { field: "costeLinea", headerName: "Coste Linea", flex: 1 }
              ]}
              columnasEditables={["cantidad", "horas", "coste"]}
              columnasAlineadasDerecha={["cantidad", "horas", "coste", "costeLinea"]}
              processRowUpdate={(newRow, oldRow) =>
                modificarLineaDetalle(newRow, oldRow, `/utilidades/actualizaLineaDetalle/${newRow.id}/parteTrabajoPersonalPrimeraLinea`)
              }
            />
          </Box>
        )}

        {/* CADEVESA */}
        {subTabPrimeraLinea === 1 && (
          <Box sx={{ mb: 2 }}>
            <GridListadoEditable
              pageSize={100}
              iconoEditar="No"
              iconoBorrar="No"
              rows={filtroPrimeraLineaCadevesa}
              columnas={[
                { field: "nombre", headerName: "Nombre", flex: 1, renderCell: p => p.row.categoria?.nombre || "—" },
                { field: "cantidad", headerName: "Cantidad", flex: 1 },
                { field: "horas", headerName: "Horas", flex: 1 },
                { field: "coste", headerName: "Coste", flex: 1 },
                { field: "costeLinea", headerName: "Coste Linea", flex: 1 }
              ]}
              columnasEditables={["cantidad", "horas", "coste"]}
              columnasAlineadasDerecha={["cantidad", "horas", "coste", "costeLinea"]}
              processRowUpdate={(newRow, oldRow) =>
                modificarLineaDetalle(newRow, oldRow, `/utilidades/actualizaLineaDetalle/${newRow.id}/parteTrabajoPersonalPrimeraLinea`)
              }
            />
          </Box>
        )}

        {/* Adecco Eventuales */}
        {subTabPrimeraLinea === 2 && (
          <Box sx={{ mb: 2 }}>
            <GridListadoEditable
              pageSize={100}
              iconoEditar="No"
              iconoBorrar="No"
              rows={filtroPrimeraLineaAdeccoEventuales}
              columnas={[
                { field: "nombre", headerName: "Nombre", flex: 1, renderCell: p => p.row.categoria?.nombre || "—" },
                { field: "cantidad", headerName: "Cantidad", flex: 1 },
                { field: "horas", headerName: "Horas", flex: 1 },
                { field: "coste", headerName: "Coste", flex: 1 },
                { field: "costeLinea", headerName: "Coste Linea", flex: 1 }
              ]}
              columnasEditables={["cantidad", "horas", "coste"]}
              columnasAlineadasDerecha={["cantidad", "horas", "coste", "costeLinea"]}
              processRowUpdate={(newRow, oldRow) =>
                modificarLineaDetalle(newRow, oldRow, `/utilidades/actualizaLineaDetalle/${newRow.id}/parteTrabajoPersonalPrimeraLinea`)
              }
            />
          </Box>
        )}

        {/* Adecco Fijos Discontinuos */}
        {subTabPrimeraLinea === 3 && (
          <Box sx={{ mb: 2 }}>
            <GridListadoEditable
              pageSize={100}
              iconoEditar="No"
              iconoBorrar="No"
              rows={filtroPrimeraLineaAdeccoFijoDiscontinuo}
              columnas={[
                { field: "nombre", headerName: "Nombre", flex: 1, renderCell: p => p.row.categoria?.nombre || "—" },
                { field: "cantidad", headerName: "Cantidad", flex: 1 },
                { field: "horas", headerName: "Horas", flex: 1 },
                { field: "coste", headerName: "Coste", flex: 1 },
                { field: "costeLinea", headerName: "Coste Linea", flex: 1 }
              ]}
              columnasEditables={["cantidad", "horas", "coste"]}
              columnasAlineadasDerecha={["cantidad", "horas", "coste", "costeLinea"]}
              processRowUpdate={(newRow, oldRow) =>
                modificarLineaDetalle(newRow, oldRow, `/utilidades/actualizaLineaDetalle/${newRow.id}/parteTrabajoPersonalPrimeraLinea`)
              }
            />
          </Box>
        )}

      </TabPanel>

      {/*************************************************************************
      ********** Panel Segunda Linea (2)
      ************************************************************************ */}
      <TabPanel value={tabIndex} index={2}>
        <Typography variant="h5" gutterBottom mb={2}>Personal de Segunda Linea</Typography>

        <GridListadoEditable
          pageSize={100}
          iconoEditar="No"
          iconoBorrar="No"
          rows={personalSegundaLinea}
          columnas={[
            { field: "nombre", headerName: "Nombre", flex: 1, renderCell: (params) => params.row.categoria?.nombre || "—" },
            { field: "cantidad", headerName: "Cantidad", flex: 1 },
            { field: "horas", headerName: "Horas", flex: 1 },
            { field: "coste", headerName: "Coste", flex: 1 },
            { field: "costeLinea", headerName: "Coste Linea", flex: 1 },
          ]}
          columnasEditables={["cantidad", "horas", "coste"]}
          columnasAlineadasDerecha={["cantidad", "horas", "coste", "costeLinea"]}
          processRowUpdate={(newRow, oldRow) =>
            modificarLineaDetalle(newRow, oldRow, `/utilidades/actualizaLineaDetalle/${newRow.id}/parteTrabajoPersonalSegundaLinea`)
          }
        />
      </TabPanel>

      {/*************************************************************************
      ********** Panel Colla (3)
      ************************************************************************ */}
      <TabPanel value={tabIndex} index={3}>
        <Typography variant="h5" gutterBottom mb={2}>Personal de Colla</Typography>

        <GridListadoEditable
          pageSize={100}
          iconoEditar="No"
          iconoBorrar="No"
          rows={personalColla}
          columnas={[
            { field: "nombre", headerName: "Nombre", flex: 1, renderCell: (params) => params.row.categoria?.nombre || "—" },
            { field: "cantidad", headerName: "Cantidad", flex: 1 },
            { field: "coste", headerName: "Coste", flex: 1 },
            { field: "costeLinea", headerName: "Coste Linea", flex: 1 },
          ]}
          columnasEditables={["cantidad", "coste"]}
          columnasAlineadasDerecha={["cantidad", "coste", "costeLinea"]}
          processRowUpdate={(newRow, oldRow) =>
            modificarLineaDetalle(newRow, oldRow, `/utilidades/actualizaLineaDetalle/${newRow.id}/parteTrabajoPersonalColla`)
          }
        />
      </TabPanel>

      {/*************************************************************************
      ********** Panel Pluses (4)
      ************************************************************************ */}
      <TabPanel value={tabIndex} index={4}>
        <Typography variant="h5" gutterBottom mb={2}>Pluses</Typography>

        <GridListadoEditable
          pageSize={100}
          iconoEditar="No"
          iconoBorrar="No"
          rows={pluses}
          columnas={[
            { field: "nombre", headerName: "Nombre", flex: 1, renderCell: (params) => params.row.plus?.nombre || "Sin relacion" },
            { field: "cantidad", headerName: "Cantidad", flex: 1 },
            { field: "coste", headerName: "Coste", flex: 1 },
            { field: "costeLinea", headerName: "Coste Linea", flex: 1 },
          ]}
          columnasEditables={["cantidad", "coste"]}
          columnasAlineadasDerecha={["cantidad", "coste", "costeLinea"]}
          processRowUpdate={(newRow, oldRow) =>
            modificarLineaDetalle(newRow, oldRow, `/utilidades/actualizaLineaDetalle/${newRow.id}/parteTrabajoPluses`)
          }
        />

      </TabPanel>

      {/*************************************************************************
      ********** Panel Medios Mecanicos (5)
      ************************************************************************ */}
      <TabPanel value={tabIndex} index={5}>
        <Typography variant="h5" gutterBottom mb={2}>Añadir Nuevo MMO</Typography>
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          mb={2}
          sx={{ width: { xs: '100%', md: '50%' } }}
        >

          <ComboApi
            endpoint="/mediosMecanicos"
            label="Medio Mecánico"
            value={valorMedioMecanicoEnComboNuevoMediosMecanico}
            onChange={(e) => setValorMedioMecanicoEnComboNuevoMediosMecanico(e.target.value)}
            seleccionarAutoPrimeraOpcion={true}
            sx={{ width: 400 }}
          />

          <IconButton
            color="primary"
            size="large"
            title="Añadir Medio Mecánico"
            onClick={() => nuevaLineaDetalle('medioMecanico')}
          >
            <AddCircleIcon fontSize="large" />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Typography variant="h5" gutterBottom mb={2}>Listado de Medio Mecánico Utilizado</Typography>

        <GridListadoEditable
          iconoEditar="No"
          rows={mediosMecanicos}
          columnas={[
            { field: "nombre", headerName: "Nombre", flex: 1, renderCell: (params) => params.row.medio_mecanico?.nombre || "—" },
            { field: "cantidad", headerName: "Cantidad", flex: 1 },
            { field: "horas", headerName: "Horas", flex: 1 },
            { field: "coste", headerName: "Coste", flex: 1 },
            { field: "costeLinea", headerName: "Coste Linea", flex: 1 }
          ]}
          columnasEditables={["cantidad", "horas", "coste"]}
          columnasAlineadasDerecha={["cantidad", "horas", "coste", "costeLinea"]}
          onEliminarClick={(row) => eliminarLineaDetalle(row, `/utilidades/borraLineaDetalle/${row.id}/parteTrabajoMedioMecanico`)}
          processRowUpdate={(newRow, oldRow) =>
            modificarLineaDetalle(newRow, oldRow, `/utilidades/actualizaLineaDetalle/${newRow.id}/parteTrabajoMedioMecanico`)
          }
        />
      </TabPanel>

      {/*************************************************************************
      ********** Panel Arrastre (6)
      ************************************************************************ */}
      <TabPanel value={tabIndex} index={6}>
        <Typography variant="h5" gutterBottom mb={2}>
          Gestión de Arrastres
        </Typography>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={2}>
            <FormControlLabel fullWidth
              control={
                <Switch
                  checked={cabeceraParte.operacion_de_arrastre === "Si"}
                  onChange={(e) =>
                    setCabeceraParte({
                      ...cabeceraParte,
                      operacion_de_arrastre: e.target.checked ? "Si" : "No",
                    })
                  }
                  color="primary"
                />
              }
              label="Operación de arrastre"
            />
          </Grid>

          <Grid item xs={1}>
            <TextField
              label="Toneladas"
              fullWidth
              size="small"
              value={cabeceraParte.toneladas_arrastre || ""}
              onChange={(e) =>
                setCabeceraParte({
                  ...cabeceraParte,
                  toneladas_arrastre: e.target.value,
                })
              }
            />
          </Grid>

          <Grid item xs={1}>
            <FormControl fullWidth size="small">
              <InputLabel>Tipo</InputLabel>
              <Select
                label="Tipo"
                value={cabeceraParte.direccion_arrastre || ""}
                onChange={(e) =>
                  setCabeceraParte({
                    ...cabeceraParte,
                    direccion_arrastre: e.target.value,
                  })
                }
              >
                <MenuItem value="Entrada">Entrada</MenuItem>
                <MenuItem value="Salida">Salida</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={2}>
            <ComboApi
              seleccionarAutoPrimeraOpcion={true}
              fullwidth={true}
              endpoint="/almacenes"
              label="Almacén"
              value={cabeceraParte.almacen_id || ""}
              onChange={(e) =>
                setCabeceraParte({
                  ...cabeceraParte,
                  almacen_id: e.target.value,
                })
              }
            />
          </Grid>

          <Grid item xs={1}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={async () => {
                try {
                  const payload = {
                    operacion_de_arrastre: cabeceraParte.operacion_de_arrastre,
                    toneladas_arrastre: cabeceraParte.toneladas_arrastre,
                    direccion_arrastre: cabeceraParte.direccion_arrastre,
                    almacen_id: cabeceraParte.almacen_id,
                  };
                  const { peticion, error } = await peticionPut(`/partesTrabajo/${cabeceraParte.id}`, payload);
                  migaPanRef.current?.mostrarSnack({
                    mensaje: peticion?.mensajeSnack || "El nuevo registro ha sido creado",
                    tipo: peticion?.tipoSnack || "success"
                  });

                } catch (error) {
                  console.error("❌ Error al guardar arrastre:", error);
                  alert("Error al guardar los datos de arrastre");
                }
              }}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </TabPanel>

      {/*************************************************************************
      ********** Panel Utilidades (7)
      ************************************************************************ */}
      <TabPanel value={tabIndex} index={7}>
        <Typography variant="h5" gutterBottom mb={2}>
          Utilidades
        </Typography>

        <Button
          variant="contained"
          color="error"
          onClick={async () => {
            if (!window.confirm("¿Seguro que quieres eliminar este parte de trabajo?")) return;

            try {
              // const { peticion, error } = await peticionDelete(`/partesTrabajo/delete/${id}`);
              const { peticion, error } = await peticionDelete(`/partesTrabajo/${id}`);


              migaPanRef.current?.mostrarSnack({
                mensaje: peticion?.mensajeSnack || (error ? "Error al eliminar" : "Parte eliminado correctamente"),
                tipo: peticion?.tipoSnack || (error ? "error" : "success"),
              });

              if (!error) {
                // 🔥 Redirigir a la operación a la que pertenece el parte
                const idOperacion = cabeceraParte?.operacion?.id;
                if (idOperacion) {
                  window.location.href = `/Operaciones/Editar/${idOperacion}`;
                } else {
                  // fallback por si acaso
                  window.location.href = `/Operaciones`;
                }
              }

            } catch (e) {
              console.error("Error al eliminar parte:", e);
              migaPanRef.current?.mostrarSnack({
                mensaje: "Error al eliminar",
                tipo: "error",
              });
            }
          }}
        >
          Eliminar Parte
        </Button>

      </TabPanel>

    </Box>
  );
};

export default PartesTrabajoDetalle;